export class ExternalLinksA11yEnhancements {
    constructor() {
        const alertA11yEnhancements = Array.prototype.slice.call(
            document.querySelectorAll('.activate-external-links-a11y-enhancements .alert-message')
        );
        const mainA11yEnhancements = document.querySelector('.activate-external-links-a11y-enhancements main');
        const footerA11yEnhancements = document.querySelector('.activate-external-links-a11y-enhancements footer');
        let externalLinks = new Array();

        function findExternalLinks(A11yEnhancementElement) {
            if (A11yEnhancementElement != null) {
                const richTextEditors = Array.prototype.slice.call(A11yEnhancementElement.querySelectorAll('.rich-text'));

                if (richTextEditors != null) {
                    richTextEditors.forEach(editor => {
                        const editorExternalLinks = Array.prototype.slice.call(editor.querySelectorAll('a[target="_blank"]'));

                        if (externalLinks != null) {
                            externalLinks.push(...editorExternalLinks);
                        }
                    });
                }
            }
        }

        function addNoOpener(link) {
            const linkTypes = (link.getAttribute('rel') || '').split(' ');

            if (!linkTypes.includes('noopener')) {
                linkTypes.push('noopener');
            }

            link.setAttribute('rel', linkTypes.join(' ').trim());
        }

        function addNewTabMessage(link) {
            if (!link.querySelector('.screen-reader-only')) {
                link.insertAdjacentHTML('beforeend', '<span class="screen-reader-only visually-hidden">(opens in a new tab)</span>');
            }
        }

        function addIcon(link) {
            let span = document.createElement('span');
            let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            let path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

            span.setAttribute('class', 'svg-container');

            svg.setAttribute('aria-hidden', 'true');
            svg.setAttribute('focusable', 'false');
            svg.setAttribute('role', 'img');
            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            svg.setAttribute('viewBox', '0 0 576 512');

            path.setAttribute('fill', 'currentColor');
            path.setAttribute(
                'd',
                'M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z'
            );

            span.appendChild(svg);
            svg.appendChild(path);
            link.appendChild(span);

            link.classList.add('external-link');
        }

        if (alertA11yEnhancements != null) {
            alertA11yEnhancements.forEach(alert => {
                const alertExternalLinks = Array.prototype.slice.call(alert.querySelectorAll('a[target="_blank"]'));

                if (alertExternalLinks != null) {
                    externalLinks.push(...alertExternalLinks);
                }
            });
        }

        findExternalLinks(mainA11yEnhancements);
        findExternalLinks(footerA11yEnhancements);

        if (externalLinks.length > 0) {
            externalLinks.forEach(link => {
                addNoOpener(link);
                addNewTabMessage(link);
                addIcon(link);
            });
        }
    }
}
